module.exports = __webpack_public_path__ + "static/media/434042272_922778682662253_2064824420655996513_n.cd40fd9c.jpg";